class Node {
  constructor(variant) {
    this.variant = variant;
    this.optionsCount = this.variant.options.length;
    this.neighbors = [];

    for (let i = 0; i < this.optionsCount; i++) {
      this.neighbors.push([]);
    }
  }

  addNeighbor(variant) {
    for (let i = 0; i < this.optionsCount; i++) {
      if (this.variant.options[i] !== variant.options[i]) {
        this.neighbors[i].push(variant);
        break;
      }
    }
  }

  getValidOptions() {
    const options = [];

    for (let i = 0; i < this.optionsCount; i++) {
      const variants = [this.variant, ...this.neighbors[i]];
      options[i] = {};

      variants.forEach(item => {
        const variant = item;
        const option = variant.options[i];

        options[i][option] = {
          available: (options[i][option] && options[i][option].available) || variant.available,
        };
      });
    }

    return options;
  }
}

export default class ProductOptions {
  constructor(product) {
    this.productHandle = product.handle;
    this.optionsCount = product.options.length;
    this.variants = product.variants;
    this.nodeMap = {};

    this._generateNodeMap(product);
  }

  _generateNodeMap() {
    this.variants.forEach(variant => {
      this.nodeMap[variant.id] = new Node(variant);

      this.variants.forEach(variant2 => {
        this.nodeMap[variant.id].addNeighbor(variant2);
      });
    });
  }

  getVariantFromOptions(options) {
    let foundVariant = false;

    this.variants.forEach(variant => {
      let found = true;

      for (let i = 0; i < variant.options.length; i++) {
        if (options[i] !== variant.options[i]) {
          found = false;
        }
      }

      if (found) {
        foundVariant = variant;
      }
    });

    return foundVariant;
  }

  getClosestVariantFromOptions(options) {
    let closestVariant = null;
    let matchingValues = 0;

    this.variants.forEach(variant => {
      let tempMatchingValues = 0;

      for (let i = 0; i < variant.options.length; i++) {
        if (options[i] === variant.options[i]) {
          tempMatchingValues++;
        } else {
          break;
        }
      }

      if (tempMatchingValues >= matchingValues) {
        closestVariant = variant;
        matchingValues = tempMatchingValues;
      }
    });

    return closestVariant || false;
  }

  getVariantOrClosestFromOptions(options) {
    return this.getVariantFromOptions(options)
      || this.getClosestVariantFromOptions(options);
  }

  getAvailableOptionsFromVariant(variant) {
    return this.nodeMap[variant.id].getValidOptions();
  }
}
